import * as Yup from "yup";

export const footerEmailSchema = Yup.object().shape({
  email: Yup.string().email("Invalid email format").required(),
});
